"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { PlusIcon } from "@heroicons/react/24/solid";
import { useContext, useMemo, useState } from "react";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
import RepCategoryPill from "../RepCategoryPill";
import RepDirectionToggle from "../RepDirectionToggle";
import { buildRepAvatarItems } from "../buildRepAvatarItems";
import UserPageRepModifyModal from "../modify-rep/UserPageRepModifyModal";
import GrantRepDialog from "../new-rep/GrantRepDialog";
import { getCanEditRep, getContributorLabel, type RepDirection } from "../UserPageRep.helpers";
export default function UserPageRepHeader(t0) {
  const $ = _c(74);
  const {
    overview,
    categories,
    profile,
    repDirection,
    onOpenOverviewContributors,
    onOpenCategoryContributors,
    onRepDirectionChange,
    loading,
    visibleCount,
    onShowMore,
    hasNextPage,
    isFetchingNextPage
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const visibleCategories = categories.slice(0, visibleCount);
  const hiddenLoadedCategoryCount = Math.max(categories.length - visibleCount, 0);
  const hasMore = hiddenLoadedCategoryCount > 0 || hasNextPage;
  let loadMoreLabel = "Load more";
  if (hiddenLoadedCategoryCount > 0) {
    loadMoreLabel = `+${hiddenLoadedCategoryCount} more`;
  } else {
    if (isFetchingNextPage) {
      loadMoreLabel = "Loading...";
    }
  }
  const isLoadMoreDisabled = isFetchingNextPage && hiddenLoadedCategoryCount === 0;
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== profile) {
    t1 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = profile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const canEditRep = t1;
  let t2;
  if ($[4] !== overview?.contributors.data) {
    t2 = () => buildRepAvatarItems(overview?.contributors.data ?? [], 5);
    $[4] = overview?.contributors.data;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  overview?.contributors.data;
  let t3;
  if ($[6] !== t2) {
    t3 = t2();
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const avatarItems = t3;
  const [editCategory, setEditCategory] = useState(null);
  const [isGrantRepOpen, setIsGrantRepOpen] = useState(false);
  const t4 = "tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-gradient-to-br tw-from-[#0f1014] tw-via-[#0A0A0C] tw-to-[#08090b] tw-shadow-2xl";
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-500/[0.05] tw-via-transparent tw-to-transparent tw-opacity-100" />;
    t6 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-[1px] tw-bg-gradient-to-r tw-from-transparent tw-via-blue-400/40 tw-to-transparent" />;
    t7 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    t8 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  const t9 = "tw-relative tw-p-6";
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Rep</h2>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = repDirection === "received" ? "What others recognize this identity for." : "What this identity recognizes others for.";
  let t12;
  if ($[13] !== t11) {
    t12 = <p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">{t11}</p>;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== onRepDirectionChange || $[16] !== repDirection) {
    t13 = <div className="tw-mt-4"><RepDirectionToggle repDirection={repDirection} onRepDirectionChange={onRepDirectionChange} /></div>;
    $[15] = onRepDirectionChange;
    $[16] = repDirection;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12 || $[19] !== t13) {
    t14 = <div className="tw-min-w-0">{t10}{t12}{t13}</div>;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Total Rep</div>;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== overview) {
    t16 = overview ? formatNumberWithCommas(overview.total_rep) : "\u2014";
    $[22] = overview;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t16) {
    t17 = <div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-primary-400">{t16}</div>;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== avatarItems || $[27] !== onOpenOverviewContributors || $[28] !== overview || $[29] !== repDirection) {
    t18 = overview && <div className="tw-mt-3 tw-flex tw-items-center tw-gap-2">{avatarItems.length > 0 && <OverlappingAvatars items={avatarItems} size="md" maxCount={5} />}{overview.contributor_count > 0 ? <button type="button" onClick={onOpenOverviewContributors} aria-label={`View all ${getContributorLabel(repDirection, overview.contributor_count)}`} className="tw-inline-flex tw-items-center tw-border-none tw-bg-transparent tw-p-0 tw-text-sm tw-font-normal tw-text-iron-400 tw-underline tw-decoration-white/10 tw-underline-offset-4 tw-transition-[text-decoration-color] hover:tw-text-iron-200 hover:tw-decoration-white/50">{formatNumberWithCommas(overview.contributor_count)}{" "}{getContributorLabel(repDirection, overview.contributor_count)}</button> : <span className="tw-text-sm tw-font-normal tw-text-iron-400">{formatNumberWithCommas(overview.contributor_count)}{" "}{getContributorLabel(repDirection, overview.contributor_count)}</span>}</div>;
    $[26] = avatarItems;
    $[27] = onOpenOverviewContributors;
    $[28] = overview;
    $[29] = repDirection;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t17 || $[32] !== t18) {
    t19 = <div className="tw-flex tw-flex-shrink-0 tw-flex-col tw-items-end tw-text-right">{t15}{t17}{t18}</div>;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t14 || $[35] !== t19) {
    t20 = <div className="tw-flex tw-items-end tw-justify-between tw-gap-6">{t14}{t19}</div>;
    $[34] = t14;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const t21 = (visibleCategories.length > 0 || canEditRep && repDirection === "received") && <div className="tw-mt-5 tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-white/10 tw-pt-5"><div className="tw-mb-4 tw-flex tw-items-center tw-justify-between"><div className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Rep Categories</div>{overview !== null && overview.authenticated_user_contribution !== null && overview.authenticated_user_contribution !== 0 && <div className="tw-inline-flex tw-items-center tw-gap-x-1.5"><span className="tw-text-xs tw-font-normal tw-text-iron-400">{repDirection === "given" ? "Assigned To You:" : "You Assigned:"}</span><span className="tw-text-xs tw-font-semibold tw-text-iron-300">{overview.authenticated_user_contribution > 0 && "+"}{formatNumberWithCommas(overview.authenticated_user_contribution)}</span></div>}</div><div className="tw-flex tw-flex-wrap tw-gap-3 tw-overflow-x-auto tw-scrollbar-thin tw-scrollbar-track-transparent tw-scrollbar-thumb-white/10">{canEditRep && repDirection === "received" && <button type="button" onClick={() => setIsGrantRepOpen(true)} className="hover:tw-text-primary-200/90 tw-inline-flex tw-h-11 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-dashed tw-border-primary-400/45 tw-bg-primary-500/5 tw-px-4 tw-text-sm tw-font-medium tw-text-primary-300/85 tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-out hover:tw-border-primary-300/70 hover:tw-bg-primary-500/10"><PlusIcon aria-hidden="true" className="-tw-ml-1 tw-h-4 tw-w-4 tw-flex-shrink-0" /><span>Add new</span></button>}{visibleCategories.map(cat => <RepCategoryPill key={cat.category} category={cat} canEdit={canEditRep && repDirection === "received"} onEdit={setEditCategory} onOpenContributors={onOpenCategoryContributors} direction={repDirection} />)}{hasMore && <button type="button" onClick={onShowMore} disabled={isLoadMoreDisabled} className="tw-inline-flex tw-h-11 tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-4 tw-text-sm tw-font-medium tw-text-iron-400 tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-out hover:tw-border-white/20 hover:tw-bg-white/10 hover:tw-text-white disabled:tw-cursor-default disabled:tw-opacity-70">{loadMoreLabel}</button>}</div></div>;
  let t22;
  if ($[37] !== canEditRep || $[38] !== categories.length || $[39] !== loading || $[40] !== repDirection) {
    t22 = categories.length === 0 && !loading && !(canEditRep && repDirection === "received") && <div className="tw-mt-4 tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-white/10 tw-pt-4"><p className="tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-500">{repDirection === "given" ? "This identity hasn't given any rep yet." : "This identity hasn't received any rep yet."}</p></div>;
    $[37] = canEditRep;
    $[38] = categories.length;
    $[39] = loading;
    $[40] = repDirection;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== canEditRep || $[43] !== categories.length || $[44] !== loading || $[45] !== repDirection) {
    t23 = categories.length === 0 && loading && !(canEditRep && repDirection === "received") && <div className="tw-mt-4 tw-flex tw-justify-center tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-white/10 tw-py-4"><div className="tw-h-6 tw-w-6 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-iron-700 tw-border-t-iron-400" /></div>;
    $[42] = canEditRep;
    $[43] = categories.length;
    $[44] = loading;
    $[45] = repDirection;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t20 || $[48] !== t21 || $[49] !== t22 || $[50] !== t23) {
    t24 = <div className={t9}>{t20}{t21}{t22}{t23}</div>;
    $[47] = t20;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t24 || $[53] !== t5 || $[54] !== t6 || $[55] !== t7 || $[56] !== t8) {
    t25 = <div className={t4}>{t5}{t6}{t7}{t8}{t24}</div>;
    $[52] = t24;
    $[53] = t5;
    $[54] = t6;
    $[55] = t7;
    $[56] = t8;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== canEditRep || $[59] !== editCategory || $[60] !== profile || $[61] !== setEditCategory) {
    t26 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[58] = canEditRep;
    $[59] = editCategory;
    $[60] = profile;
    $[61] = setEditCategory;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== setIsGrantRepOpen) {
    t27 = () => setIsGrantRepOpen(false);
    $[63] = setIsGrantRepOpen;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== isGrantRepOpen || $[66] !== overview || $[67] !== profile || $[68] !== t27) {
    t28 = <GrantRepDialog profile={profile} overview={overview} isOpen={isGrantRepOpen} onClose={t27} />;
    $[65] = isGrantRepOpen;
    $[66] = overview;
    $[67] = profile;
    $[68] = t27;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== t25 || $[71] !== t26 || $[72] !== t28) {
    t29 = <>{t25}{t26}{t28}</>;
    $[70] = t25;
    $[71] = t26;
    $[72] = t28;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  return t29;
}